/**
 * OpenAI TTS Voice Configuration
 * Contains all available voice options for male and female avatars using OpenAI TTS
 */

export const VOICE_OPTIONS = {
  male: [
    {
      id: 'onyx',
      name: 'Michael (Onyx)',
      description: 'Deep, authoritative voice perfect for professional guidance',
      category: 'Professional'
    },
    {
      id: 'echo',
      name: 'Coach Marcus (Echo)',
      description: 'Warm, conversational tone that puts clients at ease',
      category: 'Friendly'
    },
    {
      id: 'fable',
      name: 'Mentor David (Fable)',
      description: 'Clear, professional delivery with excellent clarity',
      category: 'Professional'
    }
  ],
  female: [
    {
      id: 'nova',
      name: 'Sarah (Nova)',
      description: 'Clear, professional tone with therapeutic warmth',
      category: 'Professional'
    },
    {
      id: 'alloy',
      name: 'Coach Emma (Alloy)',
      description: 'Warm, friendly voice that creates instant connection',
      category: 'Friendly'
    },
    {
      id: 'shimmer',
      name: 'Therapist Lisa (Shimmer)',
      description: 'Soft, calming tone perfect for relaxation and healing',
      category: 'Calming'
    }
  ]
};

export const DEFAULT_VOICES = {
  male: 'onyx',   // Michael - Professional, authoritative voice
  female: 'nova'  // Sarah - Professional
};

export const VOICE_CATEGORIES = {
  Professional: { color: '#2196F3', description: 'Clear, authoritative voices for professional guidance' },
  Friendly: { color: '#4CAF50', description: 'Warm, approachable voices for comfortable conversations' },
  Calming: { color: '#9C27B0', description: 'Gentle, soothing voices for relaxation and healing' }
};
